module.exports = __webpack_public_path__ + "img/notify_danger.4deba230.svg";